var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAthletesWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85661 5.61337C5.19327 7.47004 6.42661 8.67005 7.99661 8.67005C9.56661 8.67005 10.7733 7.50004 11.1366 5.6167C11.1699 5.4367 11.4766 3.84669 11.4933 3.48002C11.5333 2.59335 11.2133 1.74668 10.5899 1.09667C9.92327 0.400002 8.97994 0 7.99661 0C7.01327 0 6.04994 0.406669 5.37994 1.11667C4.76327 1.77001 4.45327 2.61002 4.50327 3.48335C4.52327 3.84669 4.82661 5.43337 4.85994 5.61003L4.85661 5.61337ZM5.86327 1.58001C6.40994 1.00334 7.18661 0.670004 7.99661 0.670004C8.80661 0.670004 9.56661 0.993339 10.1066 1.56001C10.6033 2.07668 10.8566 2.75002 10.8266 3.45335C10.8166 3.69336 10.6133 4.80336 10.4799 5.49337C10.2466 6.70671 9.47327 8.00671 7.99661 8.00671C6.51994 8.00671 5.72327 6.65671 5.51327 5.49337C5.37994 4.80336 5.17994 3.69002 5.16661 3.45002C5.12661 2.76335 5.37327 2.10001 5.86327 1.58001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6233 12.8762C15.4633 11.9429 14.6767 11.2295 13.5 10.9662L7.99667 9.99951L2.48 10.9762C1.34 11.2129 0.533333 11.9462 0.37 12.8962L0 16.0062H16L15.6267 12.8795L15.6233 12.8762ZM0.71 15.3362L1.02667 12.9962C1.16333 12.2029 1.93667 11.7695 2.60667 11.6295L7.99667 10.6762L13.37 11.6195C13.7967 11.7162 14.8033 12.0429 14.9633 12.9762L15.28 15.3362H0.71Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAthletesWhite);
export default __webpack_public_path__ + "static/media/athletes-white.3e587cc4930b7e008a90790a3791827c.svg";
export { ForwardRef as ReactComponent };